import { apiFetch } from '../../../utils/apiFetch';

const API_BASE = 'https://api.glowytics.com';

/**
 * Fetch with brand-scoped headers. All API calls in OverviewV9 go through this.
 *
 * @param {string} path - API path (e.g. '/api/brands/{brandId}/live/google-ads/today')
 * @param {string} brandId - Brand ID for X-Brand-ID header
 * @param {object} [options] - Additional fetch options
 * @returns {Promise<Response>}
 */
export async function fetchWithBrand(path, brandId, options = {}) {
  const url = `${API_BASE}${path}`;
  return apiFetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Brand-ID': brandId,
      ...(options.headers || {}),
    },
    ...options,
  });
}

/**
 * Convenience: fetch JSON with brand scope.
 * Returns parsed JSON or throws on non-ok response.
 */
export async function fetchJSON(path, brandId, options = {}) {
  const res = await fetchWithBrand(path, brandId, options);
  if (!res.ok) throw new Error(`API ${res.status}: ${path}`);
  return res.json();
}
